import React from 'react';

interface ComingSoonProps {
  featureName: string;
  message?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ 
  featureName, 
  message = 'This feature is currently being prepared and will be available soon.' 
}) => (
  <div className="bg-deep-navy bg-opacity-10 rounded-lg p-4 text-center">
    <h3 className="text-lg font-heading font-bold text-deep-navy">
      {featureName} Coming Soon
    </h3>
    <p className="text-gray-600 mt-2">
      {message}
    </p>
  </div>
);

export default ComingSoon;
